module.exports = __webpack_public_path__ + "media/images/kid0-50dba671100d00e5c4fd0d177bb34a6a.png";